import * as React from "react"
import { connect } from 'react-redux'
import { ChromePicker } from "react-color"
import { CustomPalette, CustomPalettesFormType } from "app/types/model-types"
import { ColorType, Cover, Popover } from "shape-edit/forms/transparent-color"

import {
    updateInputValue as change,
} from "app/reducers/form";

import {
    css,
    GridCell,
    Grid,
    TextInput,
    Button,
    Theme,
} from "@bdfx/mergado-ui-kit"
import { stringToHash } from "shape-edit/forms/helpers"
import { selectFormValues } from "app/reducers/form"

interface Props {
    paletteIdx: number
    close: Function
    handleSaveCustomPalettesForm: Function
    customPalettesForm: CustomPalettesFormType
    change: typeof change
    initialPalette: CustomPalette
}

interface State {
    editedColorIdx: number
}

class EditPaletteModal extends React.Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            editedColorIdx: 0,
        }
    }

    handleChangeComplete = (color: ColorType) => {
        const { paletteIdx } = this.props
        const { editedColorIdx } = this.state

        if (editedColorIdx !== null) {
            const a = Math.round(color.rgb.a * 255).toString(16)
            const suffix = color.rgb.a !== 1 ? (a.length === 1 ? ('0' + a) : a) : ''
            const finalHexColor = color.hex + suffix
            this.props.change("customPalettesForm", `palettes.${paletteIdx}.colors.${editedColorIdx}`, finalHexColor)
        }
    }

    handleResetForm = () => {
        const { paletteIdx, initialPalette } = this.props
        this.props.change("customPalettesForm", `palettes.${paletteIdx}`, { ...initialPalette })
    }

    render() {
        const { customPalettesForm, paletteIdx } = this.props
        const { editedColorIdx } = this.state

        const customPalette = customPalettesForm.palettes[paletteIdx]
        const noChanges = stringToHash(JSON.stringify(this.props.initialPalette)) === stringToHash(JSON.stringify(customPalette))

        return (
            <StyledGrid>
                <GridCell className={'above-cover'}>
                    <Grid cols={'repeat(auto-fit, minmax(80px, 1fr))'} gap={'10px'}>
                    {customPalette.colors.map((color: string, colorIdx: number) => {
                        return <GridCell
                            key={`g_${color}_${colorIdx}`}
                            className={'clickable centered'}
                            style={{ background: color, border: '2px solid ' + (colorIdx === editedColorIdx ? '#000' : 'transparent') }}
                            onClick={() => this.setState({ editedColorIdx: colorIdx })}>{color}
                        </GridCell>
                    })}
                    </Grid>
                </GridCell>
                <GridCell className={'centered'}>
                    {editedColorIdx !== null &&
                        <div style={{ position: 'relative' }}>
                            <Popover />
                            <ChromePicker
                                color={customPalette.colors[editedColorIdx]}
                                colors={customPalette}
                                onChangeComplete={this.handleChangeComplete}
                            />
                        </div>
                    }
                </GridCell>

                <GridCell className={'palette-name above-cover'} col={'1/-1'}><TextInput name={`customPalettesForm.palettes.${paletteIdx}.name`} /></GridCell>

                <GridCell className={'above-cover'}>
                    {/* <Button color={Theme.green} type={'void'} disabled={noChanges} onClick={this.props.close}>{trans('save_custom_colors')}</Button> */}
                </GridCell>
                <GridCell className={'above-cover right'}>
                    <Button
                        type={'void'}
                        size={'small'}
                        onClick={(e) => this.handleResetForm()}
                    >Reset</Button>
                </GridCell>
            </StyledGrid>
        )
    }
}

const StyledGrid = css(Grid)({
    gridTemplateColumns: '220px auto',
    /* gridRowGap: '20px',
    gridColumnGap: '10px', */
    gridGap: '20px',
    justifyContent: 'space-around',
    ' .muk-gridcell': {
        alignSelf: 'center',
        textAlign: 'center',
    },
    ' .above-cover': {
        zIndex: 999,
        pointerEvents: 'auto',
    },
    ' .right': {
        textAlign: 'right',
    },
    ' .centered': {
        textAlign: 'center',
    },
})


function mapStateToProps(state) {
    return {
        customPalettesForm: selectFormValues(state, 'customPalettesForm'),
    }
}

export default connect(mapStateToProps, {
    change,
})(EditPaletteModal)
